export default {"src":"/_next/static/media/not-found.bef2a5b3.svg","height":854,"width":1368,"blurWidth":0,"blurHeight":0};